import { TicketStatusNameType } from "../views/HomeView/HomeView";

export const getStatusColor = (status: TicketStatusNameType): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
    switch (status) {
      case 'citation received (Approving)':
        return 'default';
      case 'case accepted (Approved)':
        return 'info';
      case 'letter of representation sent (Active)':
        return 'primary';
      case 'court respond by date satisfied (Pending)':
        return 'info';
      case 'New court date':
        return 'info';
      case 'negotiating with prosecutor':
        return 'warning';
      case 'offer received':
        return 'primary';
      case 'waiting for client to reject or accept offer':
        return 'warning';
      case 'waiting for judge to approve':
        return 'secondary';
      case 'deferral/DSC conditions':
        return 'warning';
      case 'case closed/dismissed (closed)':
        return 'success';
      default:
        return 'default';
    }
  };